import LoginComponent from "../../components/Login"

const Index = () => {
    return (
        <LoginComponent></LoginComponent>
    )
}
export default Index
